



































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Translation from '@/components/i18n/Translation.vue';
import TranslationSource from '@/types/i18n/TranslationSource';
import FormField from '@/components/form/FormField.vue';

@Component({
  components: { Translation, FormField },
})
export default class DiscountCheckboxField extends Vue {
  @Prop(Boolean)
  public checked!: boolean;

  @Prop(Boolean)
  public disabled!: boolean;

  @Prop({ type: Boolean, default: true })
  public labelIsPath!: boolean;

  @Prop(String)
  public identifier!: string;

  @Prop(String)
  public label!: string;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Array)
  public options!: Array<{ value: string | number; label: string | number }>;

  @Emit()
  public infoClick(): void {}

  public mounted(): void {
    const input = this.$refs.input as any;
    if (input) {
      input.checked = this.checked;
    }
  }

  @Watch('checked', { immediate: true })
  public onCheckedChanged(checked: boolean): void {
    const input = this.$refs.input as any;
    if (input) {
      input.checked = checked;
    }
  }
}
